import {InjectionToken} from '@angular/core';
import {ICaptchaService} from './services/captcha-service.interface';
import {IRecaptcha, IRecaptchaEnterprise} from './types/recaptcha';
import {ICaptchaConfiguration} from './configuration/captcha-configuration.interface';
import {Observable} from 'rxjs';

/**
 * @internal
 * Allows for the injection of a typed-version of Window that includes
 * a reference to the reCAPTCHA script and an associated loaded() event.
 */
export const CaptchaWindow = new InjectionToken<Window & {
    grecaptcha: IRecaptcha | IRecaptchaEnterprise;
    captchaLoaded(): void;
}>('WINDOW');

/**
 * @internal
 * An injection token for the CAPTCHA configuration required by a particular environment.
 * The implementing application's configuration file must extend ICaptchaConfiguration.
 */
export const EnvironmentConfiguration = new InjectionToken<Observable<ICaptchaConfiguration>>('ENVIRONMENT_CONFIGURATION');

/**
 * Provides the CaptchaService.
 */
export const CaptchaService = new InjectionToken<ICaptchaService>('CAPTCHA_SERVICE');
